import { CanDeactivateFn } from '@angular/router';
import { ComponentCanDeactivate } from '@pages/third-party-idp/models/component-can-deactivate.interface';
import { Observable } from 'rxjs';

export const canDeactivateComponentGuard: CanDeactivateFn<ComponentCanDeactivate> = (
  component: ComponentCanDeactivate
): Observable<boolean> => component.canDeactivate();
